/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetQuestPhotoRequirementsResponse
 */
export interface GetQuestPhotoRequirementsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetQuestPhotoRequirementsResponse
     */
    prompt: string;
    /**
     * 
     * @type {object}
     * @memberof GetQuestPhotoRequirementsResponse
     */
    schema: object;
}

/**
 * Check if a given object implements the GetQuestPhotoRequirementsResponse interface.
 */
export function instanceOfGetQuestPhotoRequirementsResponse(value: object): value is GetQuestPhotoRequirementsResponse {
    if (!('prompt' in value) || value['prompt'] === undefined) return false;
    if (!('schema' in value) || value['schema'] === undefined) return false;
    return true;
}

export function GetQuestPhotoRequirementsResponseFromJSON(json: any): GetQuestPhotoRequirementsResponse {
    return GetQuestPhotoRequirementsResponseFromJSONTyped(json, false);
}

export function GetQuestPhotoRequirementsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestPhotoRequirementsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'schema': json['schema'],
    };
}

export function GetQuestPhotoRequirementsResponseToJSON(json: any): GetQuestPhotoRequirementsResponse {
    return GetQuestPhotoRequirementsResponseToJSONTyped(json, false);
}

export function GetQuestPhotoRequirementsResponseToJSONTyped(value?: GetQuestPhotoRequirementsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prompt': value['prompt'],
        'schema': value['schema'],
    };
}

